import {
  type CaptureAdminApiErrorOptions,
  captureAdminApiError,
  markAdminSentryCaptured,
} from '@diamond/shared/utils';

type CaptureAdminDataAccessErrorOptions = CaptureAdminApiErrorOptions & {
  message?: string;
};

export function captureAdminDataAccessError({
  message,
  ...captureOptions
}: CaptureAdminDataAccessErrorOptions): Error {
  captureAdminApiError(captureOptions);

  const publicError = new Error(message);
  markAdminSentryCaptured(publicError);
  return publicError;
}
